import React, { useRef, useState, useEffect } from 'react';
import FileDropzone from 'src/common/FileDropzone';

interface Props {
  onSelectFiles: (files: File[]) => void;
}

export const DashboardLibraryContentAddPanelUploadFiles = ({ onSelectFiles }: Props) => {
  const inputFileElementRef = useRef<HTMLInputElement>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const onUploadFilesButtonClicked = () => {
    inputFileElementRef.current?.click();
  };

  const handleFilesUpdate = (files: File[]) => {
    setSelectedFiles(files);
    onSelectFiles(files);
  };

  useEffect(() => {
    return () => {
      setSelectedFiles([]);
      onSelectFiles([]);
    };
  }, []);

  return (
    <>
      <button className='btn-bedrock-primary' onClick={onUploadFilesButtonClicked}>
        <span className='text-bedrock-p-strong'>Select Files</span>
      </button>
      {selectedFiles.length > 0 && (
        <div className='mt-2'>
          <p className='text-bedrock-p'>Selected files:</p>
          <ul className='list-disc list-inside'>
            {selectedFiles.map((file, index) => (
              <li key={index} className='text-bedrock-p'>
                {file.name}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className='hidden'>
        <FileDropzone
          type='file'
          className='file-dropzone'
          multiple
          onFilesUpdate={handleFilesUpdate}
          resetOnSuccess
          dropzoneClasses={null}
          inputRef={inputFileElementRef}
        />
      </div>
    </>
  );
};
